import Backbone from 'backbone';

/**
 * NetX Enhancements to Backbone.sync:
 *
 * A HTTP header is added if Netx.Session is storing an authentication token.
 */
// NOTE: this doesn't deal properly with multiple simultaneous syncs of the same model ... will that ever come up?
Backbone.sync = _.wrap(Backbone.sync, function (sync, method, model, options) {
	// Add token header to options if we have a token.
	var token = Netx.session?.getToken();
	if (token) {
		options = options || {};
		options.headers = _.extend(
			{
				'NX-Auth-Token': token,
			},
			options.headers || {},
		);
	}
	// should be a no-op.
	return sync(method, model, options);
});

/**
 * NetX Enhancements to Backbone.Events:
 *
 * retrigger
 *
 * A listener often needs to re-trigger an event on a different object, passing along the arguments it received.
 * Our current pattern do that looks like this:
 *
 *    object.trigger.apply(object, ['eventName'].concat(_.toArray(arguments)));
 *
 * Backbone.Events.retrigger() takes an event name and an 'args' parameter that's either a normal array or an arguments object,
 * so that we may instead use this much prettier pattern:
 *
 *    object.retrigger(eventName, arguments);
 *
 * @param {string} eventName
 * @param {arguments|array} args
 */
Backbone.Events.retrigger = function (eventName, args) {
	return this.trigger.apply(this, [eventName].concat(_.toArray(args)));
};

export default Backbone;
